import { useContext } from 'react';

import { TableStateContext } from '../contexts/tableState/context';

export const useTableStateContext = () => useContext(TableStateContext);
